import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { PaServiceCalculatorResponse } from '../../interfaces/pa-service-calculator.interface';
import { PaServiceCalculatorService } from 'src/app/core/services/pa-service-calculator.service';
import { PaServiceV2 } from 'src/app/core/models';
import { getTimeForUnits } from 'src/app/utils/time-functions';

@Component({
  selector: 'app-pa-service-calculator',
  templateUrl: './pa-service-calculator.component.html',
  styleUrls: ['./pa-service-calculator.component.scss']
})
export class PaServiceCalculatorComponent implements OnChanges {
  @Input() selectedPaService: PaServiceV2 | null = null;
  @Input() projectedUnits = 0;

  calculatorResponse: PaServiceCalculatorResponse | null = null;
  timeUnitsText: string = '';

  private paServiceCalculatorService = inject(PaServiceCalculatorService);

  ngOnChanges(changes: SimpleChanges) {
    if ((changes['selectedPaService'] && !changes['selectedPaService'].firstChange) ||
        (changes['projectedUnits'] && !changes['projectedUnits'].firstChange)) {
      this.loadCalculation();
    }
  }

  loadCalculation() {
    if (!this.selectedPaService?.id) return;

    this.paServiceCalculatorService.calculateUnits(this.selectedPaService.id).subscribe(
      (response) => {
        this.calculatorResponse = response;
        const used_units_this_week = response.used_units_this_week || 0;
        const average_units_per_week = response.average_units_per_week || 0;
        this.timeUnitsText = `${getTimeForUnits(used_units_this_week)} / ${getTimeForUnits(average_units_per_week)}`;
      },
      (error) => {
        console.error('Error loading PA service calculation:', error);
        this.calculatorResponse = null;
        this.timeUnitsText = '';
      }
    );
  }

  isExceedingAvailableUnits(): boolean {
    if (!this.calculatorResponse) return false;
    return (this.calculatorResponse.used_units_this_week + this.projectedUnits) > this.calculatorResponse.average_units_per_week;
  }
}
